module.exports = __webpack_public_path__ + "static/img/mobilelogo_03.fc63215.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobilelogo_03.jpg
// module id = +IV9
// module chunks = 24